import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CookieBanner from '../components/layout/CookieBanner';
import Hero from '../components/sections/Hero';
import Services from '../components/sections/Services';
import ValueProps from '../components/sections/ValueProps';
import Portfolio from '../components/sections/Portfolio';
import Results from '../components/sections/Results';
import Partners from '../components/sections/Partners';
import Testimonials from '../components/sections/Testimonials';
import FAQ from '../components/sections/FAQ';
import Contact from '../components/sections/Contact';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#f8f7f4]">
      <Header />
      <main>
        <Hero />
        <Services />
        <ValueProps />
        <Portfolio />
        <Results />
        <Partners />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};

export default Home;
